import { io } from 'socket.io-client';
import { API_BASE_URL } from './api';

let socket = null;

export const initSocket = () => {
  if (socket) return socket;

  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  
  if (!token) return null;

  // Derive socket URL from API_BASE_URL (removing /api at the end)
  const socketUrl = API_BASE_URL.replace(/\/api\/?$/, '');

  socket = io(socketUrl, {
    auth: {
      token
    },
    transports: ['websocket', 'polling']
  });

  socket.on('connect', () => {
    console.log('Connected to WebSocket server');
  });

  socket.on('disconnect', () => {
    console.log('Disconnected from WebSocket server');
  });

  return socket;
};

export const getSocket = () => {
  if (!socket) return initSocket();
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
